import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
  template: `
    <ion-app>
      <ion-router-outlet></ion-router-outlet>
    </ion-app>
  `,
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private zone: NgZone) {}

  async ngOnInit(): Promise<void> {
    // Le web ouvre directement l'URL réelle du QR (window.location porte les params),
    // donc rien à faire. Sur natif, Capacitor ne charge pas l'URL de l'App Link dans
    // la WebView (servie depuis https://localhost) : on doit l'appliquer au routeur.
    if (!Capacitor.isNativePlatform()) return;

    // Cold start : app lancée par un deep link.
    const launch = await App.getLaunchUrl();
    if (launch?.url) {
      this.navigateFromUrl(launch.url);
    }

    // App déjà ouverte (launchMode="singleTask" → onNewIntent).
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.navigateFromUrl(event.url);
    });
  }

  private navigateFromUrl(url: string): void {
    try {
      const parsed = new URL(url);
      const target = parsed.pathname + parsed.search;
      // Le callback Capacitor s'exécute hors zone Angular : sans zone.run,
      // ni le routeur ni la détection de changement ne réagissent.
      this.zone.run(() => this.router.navigateByUrl(target));
    } catch {
      // URL malformée : on ignore.
    }
  }
}
